/* TrendHome Reviews — Widget storefront (vanilla JS, zéro dépendance) */
(() => {
  const root = document.getElementById("trh-reviews");
  if (!root) return;

  const API = root.dataset.apiBase;
  const PRODUCT = {
    id: root.dataset.productId,
    handle: root.dataset.productHandle,
    title: root.dataset.productTitle,
  };

  const els = {
    summary: root.querySelector("[data-trh-summary]"),
    filters: root.querySelector("[data-trh-filters]"),
    list: root.querySelector("[data-trh-list]"),
    more: root.querySelector("[data-trh-more]"),
    form: root.querySelector("[data-trh-form]"),
    formToggle: root.querySelector("[data-trh-toggle-form]"),
    formMsg: root.querySelector("[data-trh-form-msg]"),
    starInput: root.querySelector("[data-trh-star-input]"),
  };

  // Seuil d'affichage du bloc résumé (note moyenne + barres) : dès 3 avis.
  const SUMMARY_MIN = 3;

  const state = { sort: "recent", rating: 0, page: 1, selectedStars: 0 };

  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  const starIcon = (on) =>
    `<svg class="${on ? "is-on" : "is-off"}" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
       <path d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.4l-5.8 3.1 1.1-6.5L2.6 9.4l6.5-.9L12 2.6z"/></svg>`;

  const stars = (n) =>
    `<span class="trh__stars" aria-label="${n} sur 5">${[1,2,3,4,5].map((i) => starIcon(i <= n)).join("")}</span>`;

  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

  // ---------- Fetch + rendu ----------
  async function load(append = false) {
    if (!append) els.list.innerHTML = `<p class="trh__loading">Chargement des avis…</p>`;
    const p = new URLSearchParams({ product_id: PRODUCT.id, sort: state.sort, page: state.page });
    if (state.rating) p.set("rating", state.rating);

    let data;
    try {
      const res = await fetch(`${API}/reviews?${p}`);
      data = await res.json();
    } catch {
      els.list.innerHTML = `<p class="trh__empty">Impossible de charger les avis pour le moment.</p>`;
      return;
    }

    renderSummary(data.summary);
    renderFilters(data.summary);
    renderList(data.reviews, append, data.summary.total);
    els.more.hidden = !data.has_more;
  }

  function renderSummary(s) {
    if (!s.total || s.total < SUMMARY_MIN) { els.summary.hidden = true; return; }
    els.summary.hidden = false;
    els.summary.innerHTML = `
      <div class="trh__score">
        <div class="trh__score-num">${s.average.toLocaleString("fr-FR")}</div>
        ${stars(Math.round(s.average))}
        <div class="trh__score-sub">${s.total} avis vérifié${s.total > 1 ? "s" : ""}</div>
      </div>
      <div class="trh__bars">
        ${[5,4,3,2,1].map((n) => `
          <button type="button" class="trh__bar" data-rating="${n}"
                  aria-pressed="${state.rating === n}"
                  aria-label="Filtrer : ${n} étoiles (${s.counts[n-1]} avis)">
            <span>${n} ★</span>
            <span class="trh__bar-track"><span class="trh__bar-fill" data-w="${s.total ? (s.counts[n-1] / s.total) * 100 : 0}"></span></span>
            <span class="trh__bar-count">${s.counts[n-1]}</span>
          </button>`).join("")}
      </div>`;
    requestAnimationFrame(() =>
      els.summary.querySelectorAll(".trh__bar-fill").forEach((b) => (b.style.width = b.dataset.w + "%")));

    els.summary.querySelectorAll(".trh__bar").forEach((btn) =>
      btn.addEventListener("click", () => {
        const n = +btn.dataset.rating;
        state.rating = state.rating === n ? 0 : n;
        state.page = 1;
        load();
      }));
  }

  function renderFilters(s) {
    if (!s.total || s.total < SUMMARY_MIN) { els.filters.hidden = true; return; }
    els.filters.hidden = false;
    const chips = [
      { id: "recent", label: "Plus récents", on: state.sort === "recent" && !state.rating },
      { id: "rating_desc", label: "Meilleures notes", on: state.sort === "rating_desc" },
    ];
    els.filters.innerHTML = chips.map((c) =>
      `<button type="button" class="trh__chip" data-chip="${c.id}" aria-pressed="${c.on}">${c.label}</button>`).join("");

    els.filters.querySelectorAll(".trh__chip").forEach((chip) =>
      chip.addEventListener("click", () => {
        const id = chip.dataset.chip;
        state.sort = id;
        if (id === "recent") state.rating = 0;
        state.page = 1;
        load();
      }));
  }

  function makeCard(r) {
    const card = document.createElement("article");
    card.className = "trh__card";
    card.innerHTML = `
      <div class="trh__card-top">
        <div class="trh__card-meta">
          <span class="trh__avatar" aria-hidden="true">${esc(r.author_name.trim()[0] || "•").toUpperCase()}</span>
          <div>
            <div class="trh__author">${esc(r.author_name)}${r.location ? `<span class="trh__location"> — ${esc(r.location)}</span>` : ""}${r.verified ? `<span class="trh__verified">✓ Achat vérifié</span>` : ""}</div>
            <div class="trh__date">${fmtDate(r.created_at)}</div>
          </div>
        </div>
        ${stars(r.rating)}
      </div>
      ${r.body ? `<p class="trh__card-body">${esc(r.body)}</p>` : ""}`;
    return card;
  }

  // --- Avis en attente stockés localement (visibles uniquement par leur auteur) ---
  const LS_KEY = `trh_pending_${PRODUCT.id}`;
  const getLocal = () => { try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; } catch { return []; } };
  const setLocal = (arr) => { try { localStorage.setItem(LS_KEY, JSON.stringify(arr)); } catch {} };

  function renderLocals(fetched) {
    const keep = getLocal().filter((l) =>
      Date.now() - l.ts < 21 * 864e5 &&
      !fetched.some((r) => r.author_name === l.author_name && (r.body || "") === (l.body || "")));
    setLocal(keep);
    if (!keep.length) return;
    const empty = els.list.querySelector(".trh__empty");
    if (empty) empty.remove();
    for (const l of [...keep].reverse()) els.list.prepend(makeCard(l));
  }

  function renderList(reviews, append, total) {
    if (!append) els.list.innerHTML = "";
    if (!reviews.length && !append) {
      els.list.innerHTML = total
        ? `<p class="trh__empty">Aucun avis ne correspond à ce filtre.</p>`
        : `<p class="trh__empty">Soyez le premier à donner votre avis sur ce produit.</p>`;
    } else {
      const frag = document.createDocumentFragment();
      for (const r of reviews) frag.appendChild(makeCard(r));
      els.list.appendChild(frag);
    }
    if (!append && state.page === 1) renderLocals(reviews);
  }

  // ---------- Formulaire ----------
  els.formToggle.addEventListener("click", () => {
    els.form.hidden = !els.form.hidden;
    if (!els.form.hidden) els.form.scrollIntoView({ behavior: "smooth", block: "nearest" });
  });

  els.starInput.querySelectorAll("button").forEach((btn) =>
    btn.addEventListener("click", () => {
      state.selectedStars = +btn.dataset.value;
      els.starInput.querySelectorAll("button").forEach((b) =>
        b.classList.toggle("is-on", +b.dataset.value <= state.selectedStars));
    }));

  const msg = (text, error = false) => {
    els.formMsg.textContent = text;
    els.formMsg.classList.toggle("is-error", error);
  };

  els.form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const fd = new FormData(els.form);
    if (!state.selectedStars) return msg("Choisissez une note en étoiles.", true);
    if (!fd.get("author_name")?.trim()) return msg("Indiquez votre nom.", true);
    // Le commentaire est FACULTATIF : la note + le nom suffisent.

    const btn = els.form.querySelector(".trh__submit");
    btn.disabled = true;
    msg("Envoi en cours…");

    const payload = {
      product_id: PRODUCT.id,
      product_handle: PRODUCT.handle,
      product_title: PRODUCT.title,
      rating: state.selectedStars,
      author_name: fd.get("author_name").trim(),
      // La wilaya/ville est détectée côté serveur via l'IP (context.geo)
      body: fd.get("body")?.trim() || "",
      website: fd.get("website"), // honeypot
    };

    try {
      const res = await fetch(`${API}/submit-review`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Erreur");
      const localReview = {
        author_name: payload.author_name,
        body: payload.body,
        rating: payload.rating,
        location: null,
        verified: false,
        created_at: new Date().toISOString(),
        ts: Date.now(),
      };
      setLocal([...getLocal(), localReview]);
      const empty = els.list.querySelector(".trh__empty");
      if (empty) empty.remove();
      els.list.prepend(makeCard(localReview));

      els.form.reset();
      state.selectedStars = 0;
      els.starInput.querySelectorAll("button").forEach((b) => b.classList.remove("is-on"));
      msg("Merci pour votre avis ! ⭐");
      setTimeout(() => { els.form.hidden = true; msg(""); }, 1800);
    } catch (err) {
      msg(err.message === "Erreur" ? "Une erreur est survenue, réessayez." : err.message, true);
    } finally {
      btn.disabled = false;
    }
  });

  els.more.addEventListener("click", () => { state.page++; load(true); });

  load();
})();
